function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var _require = require('./overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
var OpcodeReference = /*#__PURE__*/function () {
  function OpcodeReference(app, mod) {
    _classCallCheck(this, OpcodeReference);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(OpcodeReference, [{
    key: "getSortedOpcodes",
    value: function getSortedOpcodes() {
      if (!this.mod.opcodes) {
        return [];
      }
      return Object.values(this.mod.opcodes).map(function (handler) {
        return (handler === null || handler === void 0 ? void 0 : handler.opcode) || handler;
      }).filter(function (op) {
        return op && op.name;
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
  }, {
    key: "buildDetailHtml",
    value: function buildDetailHtml(op) {
      var _this = this;
      var returns = this.returnsLine(op);
      var required = this.listRequiredFields(op);
      var example = this.compactExample(op);
      var requiredItems = required.map(function (f) {
        return "<li><code>".concat(_this.escapeHtml(f), "</code></li>");
      }).join('');
      return "\n      <p class=\"rs-ref-lead\">".concat(this.escapeHtml(returns), "</p>\n      ").concat(required.length ? "\n      <div class=\"rs-ref-section\">\n        <p class=\"rs-ref-section-label\">Required fields:</p>\n        <ul class=\"rs-ref-field-list\">".concat(requiredItems, "</ul>\n      </div>") : '', "\n      ").concat(example ? "\n      <div class=\"rs-ref-section\">\n        <p class=\"rs-ref-section-label\">Example:</p>\n        <pre class=\"rs-ref-example\">".concat(this.escapeHtml(example), "</pre>\n      </div>") : '', "\n    ");
    }
  }, {
    key: "listRequiredFields",
    value: function listRequiredFields(op) {
      var _op$exampleScript;
      var fields = new Set();
      var witness = (_op$exampleScript = op.exampleScript) === null || _op$exampleScript === void 0 ? void 0 : _op$exampleScript.witness;
      if (witness && _typeof(witness) === 'object' && !Array.isArray(witness)) {
        Object.keys(witness).forEach(function (k) {
          return fields.add(k);
        });
      }
      return Array.from(fields).sort();
    }
  }, {
    key: "returnsLine",
    value: function returnsLine(op) {
      var name = String(op.name || '').toUpperCase();
      if (name === 'CHECKSIG') {
        return 'Returns true if signature validates against message and publickey.';
      }
      if (name === 'IMPORTFIELD') {
        return 'Returns true if the signed witness value verifies, then stores it under key.';
      }
      if (name === 'IMPORTARRAY') {
        return 'Returns true if the signed witness array verifies, then stores it under key.';
      }
      if (name === 'SETFIELD') {
        return 'Returns true after copying value into a writable context.* destination.';
      }
      if (name === 'SETARRAY') {
        return 'Returns true after replacing a context location with a deep-cloned source array.';
      }
      if (name === 'SETARRAYFIELD') {
        return 'Returns true after writing a field on each destination object from a parallel source.';
      }
      if (name === 'SUMFIELDS') {
        return 'Returns true after summing two values into __opcodes.sumfields.<into>.';
      }
      if (name === 'SCRIPTHASH') {
        return 'Returns true after hashing a JSON script tree into __opcodes.scripthash.<into>.';
      }
      if (name === 'ARRAYIFY') {
        return 'Returns true after replacing a context value with deep clones of itself.';
      }
      return 'Returns boolean — true when the opcode condition is satisfied.';
    }
  }, {
    key: "compactExample",
    value: function compactExample(op) {
      if (!op.exampleScript) {
        return '';
      }
      var sample = _objectSpread({}, op.exampleScript);
      delete sample.witness;
      delete sample.required;
      return JSON.stringify(sample, null, 2);
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  }]);
}();
var OpcodesOverlay = /*#__PURE__*/function () {
  function OpcodesOverlay(app, mod) {
    _classCallCheck(this, OpcodesOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.doc = new OpcodeReference(app, mod);
    this.selectedKey = null;
  }
  return _createClass(OpcodesOverlay, [{
    key: "open",
    value: function open(initialKey) {
      this.selectedKey = initialKey ? String(initialKey).toLowerCase() : null;
      var html = buildRustscriptOverlay({
        className: 'rs-overlay-wide rs-opcode-ref-overlay',
        headHtml: "\n        <div class=\"rs-overlay-head\">\n          <h2 class=\"rs-overlay-title\">Opcode Reference</h2>\n          <select class=\"saito-form-select rs-opcode-ref-overlay-select\" aria-label=\"Select opcode\"></select>\n        </div>\n      ",
        bodyHtml: "<div class=\"rs-opcode-ref-content\" aria-live=\"polite\"></div>"
      });
      this.overlay.show(html);
      this.populateSelect();
      this.bindEvents();
      if (this.selectedKey) {
        this.selectOpcode(this.selectedKey);
      } else {
        var first = this.doc.getSortedOpcodes()[0];
        if (first) {
          this.selectOpcode(first.name.toLowerCase());
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.open(null);
    }
  }, {
    key: "populateSelect",
    value: function populateSelect() {
      var select = document.querySelector('.rs-opcode-ref-overlay-select');
      if (!select) {
        return;
      }
      select.innerHTML = '';
      var _iterator = _createForOfIteratorHelper(this.doc.getSortedOpcodes()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var op = _step.value;
          var opt = document.createElement('option');
          var key = op.name.toLowerCase();
          opt.value = key;
          opt.textContent = op.name;
          select.appendChild(opt);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.selectedKey) {
        select.value = this.selectedKey;
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _document$querySelect,
        _this2 = this;
      (_document$querySelect = document.querySelector('.rs-opcode-ref-overlay-select')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('change', function (e) {
        var key = e.target.value;
        if (key) {
          _this2.selectOpcode(key);
        }
      });
    }
  }, {
    key: "selectOpcode",
    value: function selectOpcode(key) {
      var _this$mod$opcodes;
      var normalized = String(key || '').toLowerCase();
      var handler = (_this$mod$opcodes = this.mod.opcodes) === null || _this$mod$opcodes === void 0 ? void 0 : _this$mod$opcodes[normalized];
      var op = (handler === null || handler === void 0 ? void 0 : handler.opcode) || handler;
      if (!op || !op.name) {
        return;
      }
      this.selectedKey = normalized;
      var select = document.querySelector('.rs-opcode-ref-overlay-select');
      if (select) {
        select.value = normalized;
      }
      var body = document.querySelector('.rs-opcode-ref-content');
      if (!body) {
        return;
      }
      body.innerHTML = this.doc.buildDetailHtml(op);
    }
  }]);
}();
module.exports = OpcodesOverlay;